import React from "react";
import { Link } from "react-router-dom";
import "./../../styles/home-sections/CustomSection.css";
import "./../../styles/NeonButton.css";

import routesImage from "../../assets/stone.jpg";

const ActivitiesSectionNew = () => {
  return (
    <section className="custom-section">
      <div className="custom-section-left">
        <h1>Rutas Rosas: Nuestro camino hacia Santiago</h1>
        <p>
          El Camino de Santiago es el gran reto para el que nos preparamos
          durante todo el año. Para lograrlo, nos entrenamos mediante las "Rutas
          Rosas": se componen de rutas de entrenamiento de senderismo por
          pueblos cercanos a Sevilla y de rutas mas cortas y accesibles,
          enfocadas a las mujeres que están iniciándose o bien desean caminar
          menos. Estas actividades no solo nos ayudan a prepararnos físicamente
          para el Camino, sino que también fomentan la conexión entre nosotras
          en un entorno natural y pintoresco.
        </p>
        <p>
          Además, participamos en otros eventos como reuniones informativas,
          actividades de apoyo, actividades culturales y encuentros especiales
          que fortalecen nuestro vínculo y espíritu de equipo.
        </p>
        <Link to="/actividades" className="neon-button button-left">
          Descubre nuestras actividades
        </Link>
      </div>
      <div className="custom-section-right custom-section-right-image">
        <div>
          <img
            className="section-right-img"
            src={routesImage}
            alt="Medical care in action"
          />
        </div>
      </div>
    </section>
  );
};

export default ActivitiesSectionNew;
